const SECOND = 1000

const TIMEOUTS = {
  NORMAL_TIMEOUT: 2.9 * SECOND,
  LANDING_PAGE_TIMEOUT: 10 * SECOND,
  TESTS_TIMEOUT: 30 * SECOND
}

export default TIMEOUTS
